import PhoneInputWithCountry from "react-phone-number-input/react-hook-form";
import "react-phone-number-input/style.css";

// Own components
import Icon from "../../Components/Icon";

// Model
import { PhoneNumberInputProps } from "../../Models/PhoneNumberInput";

// Own styles
import {
  PhoneNumberContainer,
  LabelPhone,
  ErrorContainer,
  ErrorMessage,
  Asterisk,
} from "./PhoneNumberInput.styled";

const PhoneNumberInput = (props: PhoneNumberInputProps) => {
  const {
    label,
    labelText,
    rules,
    errors,
    control,
    countryDefault = "GT",
    currentCountry = "GT",
    countries = ["GT"],
    disabled = false,
  } = props;

  return (
    <PhoneNumberContainer $error={errors[label]}>
      <LabelPhone>
        <Asterisk>*</Asterisk>
        {labelText}
      </LabelPhone>
      <PhoneInputWithCountry
        name="phoneNumber"
        control={control}
        international={true}
        defaultCountry={countryDefault}
        country={currentCountry}
        countries={countries}
        countryOptionsOrder={countries}
        initialValueFormat="national"
        limitMaxLength={true}
        addInternationalOption={false}
        countryCallingCodeEditable={false}
        rules={rules}
        disabled={disabled}
      />
      {errors[label] && (
        <ErrorContainer>
          <Icon
            icon="alertTriangle"
            color="Amaranth_Red"
            size="small"
            fillIcon={false}
          />
          <ErrorMessage>{errors[label].message}</ErrorMessage>
        </ErrorContainer>
      )}
    </PhoneNumberContainer>
  );
};

export default PhoneNumberInput;
